<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

          <v-flex xs12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title>{{ $t('Statement-of-Account-by-Date') }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">

              </v-text-field>

<v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> Mail Gönder

</v-btn>





              <v-menu offset-y>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>





                  <v-list-tile @click="openExcelLanguageDialog()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>









            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>

          <v-container fluid="">

            <v-layout row wrap>

              <v-flex xs12 sm12 md4 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">cached</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Transfer-Payable') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ DevirBorc | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Transfer-Receivable') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ DevirAlacak | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="subheading font-weight-bold"> {{$t('Transfer-Balance')}}: {{ DevirBakiye | bakiyekontrolsimgeli }}

                    </span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm12 md4 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">cached</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{  $t('Current-Payable') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ DonemBorc | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Current-Receivable') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ DonemAlacak | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>





                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="subheading font-weight-bold"> {{ $t('Current-Period') }} : {{ DonemBakiye | bakiyekontrolsimgeli }} </span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm12 md4 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">layers</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('General-Debit') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ ToplamBorc | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('General-Credit') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ ToplamAlacak | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="subheading font-weight-bold"> {{ $t('General-Period') }}  : {{ ToplamBakiye | bakiyekontrolsimgeli }} </span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

            </v-layout>

          </v-container>





          <v-container fluid="">

            <v-card color="grey lighten-5" flat>

              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>

                  <v-flex xs12 sm4 md2>

                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"

                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"

                      v-model="date"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm4 md2>

                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"

                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2"

                      v-model="date2"></tarihcomp>

                  </v-flex>

                  <v-flex>

                    <v-layout>

                      <div v-if="load1">

                        <v-btn color="info" @click="getList()" fab small="" dark>

                          <v-icon>search</v-icon>

                        </v-btn>

                      </div>

                      <div v-if="load">

                        <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                      </div>

                      <v-badge color="white" :overlap="true">

                        <template v-slot:badge>

                          <v-icon v-if="filtrevarmi" large color="green">

                            check_circle_outline </v-icon>

                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                          @click="filtrele()" color="info" fab dark>

                          <v-icon>filter_list</v-icon>

                        </v-btn>

                        <v-tooltip bottom="" :activator="el" v-model="tooltip">

                          <span>{{$t('Add-Search-Filter')}}</span>

                        </v-tooltip>









                      </v-badge>





                    </v-layout>

                  </v-flex>

                </v-layout>

              </v-form>

            </v-card>

            <v-layout row="" wrap>

              <v-flex xs12 sm12 md12>

                <v-card flat>

                  <v-card-title>

                    <v-spacer></v-spacer>

                  </v-card-title>

                  <div class="tarihe-gore-report-table">
                  <ReportTable
                    :headers="tariheGoreReportHeaders"
                    :items="tariheGoreReportItems"
                    storage-key="tarihegore_columns"
                    :loading="progress"
                    :has-searched="items && items.length > 0"
                    :show-search="true"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :export-title="$t('Statement-of-Account-by-Date')"
                    :export-meta-items="tariheGoreExportMetaItems"
                    :export-summary-cards="tariheGoreSummaryCards"
                    :rows-per-page-items="[50, 100, 250, 500, 1000]"
                  ></ReportTable>
                </div>

                </v-card>

                <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">

                  <v-card color="grey lighten-5">

                    <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>

                      <v-layout row="" wrap="">

                        <v-flex xs12 sm12 md6>

                          <v-card flat class="white--text">

                            <v-card color="grey lighten-5" flat="">

                              <v-card-actions>

                                <v-layout justify-space-between column>

                                  <!-- <v-autocomplete  :items="Referans" clearable="" hide-details=""

                                    v-model="Ekstreinput.ReferansKodIstenilen.Kod" :label="$t('References-Requested')"

                                    item-text="Title" item-value="Kod" max-height="400"></v-autocomplete> -->

                                    <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="Ekstreinput.ReferansKodIstenilen.Kod" >

                              </referansmerkezicomp>

                                  <v-select :items="doviztipi" hide-details="" v-model="Ekstreinput.Doviz.DovizKod"

                                    :label="$t('Currency-Type')" clearable="" item-text="DovizAdi" item-value="DovizKod"

                                    max-height="400"></v-select>

                                </v-layout>

                              </v-card-actions>

                            </v-card>

                          </v-card>

                        </v-flex>

                        <v-flex  xs12 sm12 md6>

                          <v-card flat class="white--text">

                            <v-card color="grey lighten-5" flat="">

                              <v-card-actions>

                                <v-layout justify-space-between column>

                                  <!-- <v-autocomplete :items="Referans" clearable="" hide-details=""

                                    v-model="Ekstreinput.ReferansKodIstenmeyen.Kod" :label="$t('Unwanted-References')"

                                    item-text="Title" item-value="Kod" max-height="400" persistent-hint>

                                  </v-autocomplete> -->

                                  <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="Ekstreinput.ReferansKodIstenmeyen.Kod" >

                              </referansmerkezicomp>

                                  <v-autocomplete hide-details clearable :items="evraktipi" v-model="secilenevraklar"

                                    :label="$t('Document-Type')" multiple item-text="Title" item-value="Evrakkod">

                                    <template slot="selection" slot-scope="{ item, index }">

                                      <v-chip v-if="index === 0">

                                        <h4> <span>{{ item.Evrakkod }}</span> </h4>

                                      </v-chip>

                                      <span v-if="index === 1" class="grey--text caption">(+{{

                                  secilenevraklar.length - 1 }} {{ $t('other-record') }})</span>

                                    </template>

                                  </v-autocomplete>













                                </v-layout>

                              </v-card-actions>

                            </v-card>

                          </v-card>

                        </v-flex>

                        <v-flex pb-1 pr-1 pl-1 xs12 sm12 md12>

                             <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loading" v-bind:value="Ekstreinput.AnaHesap" v-model="Ekstreinput.AnaHesap"></cariaracomp>

                        </v-flex>









                        <v-flex xs12 sm12 md12>

                          <v-card flat="" color="#9E9E9E">

                            <v-card-title>

                              <span class="subheading white--text font-weight-medium "> {{ $t('Options-v2') }} </span>

                            </v-card-title>

                          </v-card>

                        </v-flex>

                        <v-flex xs12 sm6 md6>

                          <v-layout justify-space-between column>

                            <v-checkbox v-model="Ekstreinput.DevirBakiye" :label="$t('Transfer-Balance-Viewing')" hide-details="">

                            </v-checkbox>

                            <v-checkbox v-model="Ekstreinput.HesapAdi" :label="$t('View-Account-Name')" hide-details="">

                            </v-checkbox>

                            <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm3 md3>

                          <v-layout justify-space-between column>

                            <v-radio-group hide-details="" v-model="Ekstreinput.TarihSec" :label="$t('Date') + '/' + $t('Maturity') " column>

                              <v-radio :label="$t('Date')" color="orange darken-3" value=false> </v-radio>

                              <v-radio :label="$t('Maturity')" color="orange darken-3" value=true></v-radio>

                            </v-radio-group>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm3 md3>

                          <v-layout justify-space-between column>

                            <v-radio-group hide-details="" v-model="Ekstreinput.Program" label="Program" column>

                              <v-radio :label="$t('All')" value=0> </v-radio>

                              <v-radio :label="$t('Only') + 'COPER'" value=1></v-radio>

                              <v-radio :label="'Coper' + $t('Excluding')" value=2></v-radio>

                            </v-radio-group>

                          </v-layout>

                        </v-flex>





                      </v-layout>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>

                      <v-spacer></v-spacer>

                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

                    </v-card-actions>

                  </v-card>

                </v-dialog>





                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

                  :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"

                  v-model="snackbar">

                  {{ text1 }}

                  <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

                </v-snackbar>

              </v-flex>

            </v-layout>

          </v-container>

        </v-layout>

      </v-card>





        <!-- EXCEL DİL SEÇİM DIALOG -->

        <v-dialog v-model="excelLanguageDialog" persistent max-width="420px">

            <v-card>

                <v-card-title class="headline">Excel</v-card-title>

                <v-card-text>

                    <v-select

                        :items="excelLanguages"

                        v-model="excelLanguage"

                        item-text="title"

                        item-value="locale"

                        label="Language"

                        hide-details

                    ></v-select>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn flat @click="closeExcelLanguageDialog">{{ $t('cancel_button') }}</v-btn>

                    <v-btn color="info" @click="downloadExcelWithLanguage">{{ $t('Download') }}</v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

</v-app>

  </div>

</template>





<script>

  import auth from '../../../api/auth'

  import tarihcomp from '../customcomp/tarihim'

  import helpers from "@/components/app/customcomp/helpers.js"

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import ReportTable from '@/components/app/customcomp/ReportTable.vue'
export default {

    data() {

      return {
            // Frontend Excel/HTML çıktısında eski ekstre üst bilgisini korumak için.
            exportSirketUnvani: '',

                excelLanguageDialog: false,

                excelLanguage: 'en',

                excelLanguages: [

                    { locale: 'tr', title: 'Türkçe' },

                    { locale: 'en', title: 'English' },

                    { locale: 'fr', title: 'Français' },

                    { locale: 'de', title: 'Deutsch' }

                ],



        mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "Tarihe Göre Ekstre - Statement of Account by Date",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || 'Zorunlu alan',

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

},

        PB:'TRY',

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi: false,

        search: '',

        headers: [{

            text: this.$t('Currentcode_label'),

            value: 'Cari.Kod',

            sortable: false

          },

          {

            text: this.$t('Title_label'),

            value: 'Cari.Unvan',

            sortable: false

          },

          {

            text: this.$t('Date'),

            value: 'Tarih'

          },

          {

            text: this.$t('Document-Type'),

            value: 'Evrak.Evrakkod',

            sortable: false

          },

          {

            text: this.$t('Document-No'),

            value: 'Evrakno',

            sortable: false

          },

          {

            text: this.$t('Description'),

            value: 'Aciklama',

            sortable: false

          },

          {

            text: this.$t('Maturity-Date'),

            value: 'Vade'

          },

          {

            text: this.$t('Debit'),

            value: 'Borc',

            sortable: false,

            align: 'right'

          },

          {

            text: this.$t('Credit'),

            value: 'Alacak',

            sortable: false,

            align: 'right'

          },

          {

            text: this.$t('Balance'),

            value: 'Bakiye',

            sortable: false,

            align: 'right'

          }

        ],

        EkstreHesap: {

          Current: '',

          CurrentTitle: '',

          Date: '',

          DocumentType: '',

          DocumentNumber: '',

          Explanation: '',

          DueDate: '',

          Debt: '',

          Credit: '',

          Balance: '',

          BAType: ''

        },

        Ekstreinput: {

          BaslangicTarih: null,

          BitisTarih: null,

          ReferansKodIstenilen: {

            Kod: ''

          },

          ReferansKodIstenmeyen: {

            Kod: ''

          },

          Evraklar: [],

          AnaHesap: '',

          Doviz: {

            DovizKod: ''

          },

          TarihSec: false,

          DevirBakiye: false,

          HesapAdi: false,

          Program: 0,

          SirketKodu: 0

        },

        DonemBorc: 0,

        DonemAlacak: 0,

        DonemBakiye: 0,

        ToplamAlacak: 0,

        ToplamBorc: 0,

        ToplamBakiye: 0,

        DevirAlacak: 0,

        DevirBorc: 0,

        DevirBakiye: 0,

        StartDate: null,

        EndDate: null,

        statecari: [],

        searchcari: '',

        progress: false,

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        Referans: [],

        evraktipi: [],

        secilenevraklar: [],

        doviztipi: [],

        anahesap: [],

        hesapgurubu: [],

        tumsirketler: false,

        dictionary: {

          custom: {

            masrafkodu: {

              required: () => this.$t('Please-select')

            },

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

        pagination: {

          sortBy: 'Tarih'

        },

        date: null,

        menu: false,

        modal: false,

        dateFormatted: '',

        date2: null,

        menu2: false,

        dateFormatted2: '',

        modal2: false,

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        tooltip: false,

        el: null,

        valid: true,

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    components: {

      tarihcomp,

      yetkidialog,

      cariaracomp,
      ReportTable

    },

    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              let url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              let url = '#/'

              window.open(url, '_self')

            }

          }

        });

      }





    },

    computed: {
tariheGoreReportHeaders() {
        return [
          { text: this.$t('Currentcode_label'), value: '_CariKod', visible: true, sortable: true, type: 'text', align: 'left', width: '160px' },
          { text: this.$t('Title_label'), value: '_CariUnvan', visible: true, sortable: true, type: 'text', align: 'left', width: '280px' },
          { text: this.$t('Date'), value: 'Tarih', visible: true, sortable: true, type: 'date', align: 'left', width: '140px' },
          { text: this.$t('Document-Type'), value: '_EvrakKod', visible: true, sortable: true, type: 'text', align: 'left', width: '150px' },
          { text: this.$t('Document-No'), value: '_EvrakNo', visible: true, sortable: true, type: 'text', align: 'left', width: '160px' },
          { text: this.$t('Description'), value: 'Aciklama', visible: true, sortable: true, type: 'text', align: 'left', width: '280px' },
          { text: this.$t('Maturity-Date'), value: 'Vade', visible: true, sortable: true, type: 'date', align: 'left', width: '140px' },
          { text: this.$t('Debit'), value: 'Borc', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('Credit'), value: 'Alacak', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('Balance'), value: 'Bakiye', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' }
        ]
      },

      tariheGoreReportItems() {
        return (this.items || []).map(function (item) {
          var row = Object.assign({}, item)
          row._CariKod = item && item.Cari ? (item.Cari.Kod || '') : ''
          row._CariUnvan = item && item.Cari ? (item.Cari.Unvan || '') : ''
          row._EvrakKod = item && item.Evrak ? (item.Evrak.Evrakkod || '') : ''
          row._EvrakNo = item && item.Evrak && item.Evrak.Evrakno ? item.Evrak.Evrakno : (item ? item.Evrakno : '')
          return row
        })
      },
      tariheGoreExportMetaItems() {
        var evraklar = Array.isArray(this.secilenevraklar) ? this.secilenevraklar.join(', ') : ''
        var programType = this.$t('All')
        if (this.Ekstreinput && this.Ekstreinput.Program === 1) programType = this.$t('Only') + ' COPER'
        if (this.Ekstreinput && this.Ekstreinput.Program === 2) programType = 'Coper ' + this.$t('Excluding')

        var options = []
        if (this.Ekstreinput && this.Ekstreinput.DevirBakiye) options.push(this.$t('Transfer-Balance-Viewing'))
        if (this.Ekstreinput && this.Ekstreinput.HesapAdi) options.push(this.$t('View-Account-Name'))

        return [
          { label: this.$t('Company-Title'), value: this.getExportCompanyTitle() },
          { label: this.$t('Starting-Date'), value: this.date, type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.date2, type: 'date' },
          { label: this.$t('References-Requested'), value: this.Ekstreinput && this.Ekstreinput.ReferansKodIstenilen ? this.Ekstreinput.ReferansKodIstenilen.Kod : '' },
          { label: this.$t('Unwanted-References'), value: this.Ekstreinput && this.Ekstreinput.ReferansKodIstenmeyen ? this.Ekstreinput.ReferansKodIstenmeyen.Kod : '' },
          { label: this.$t('Document-Type'), value: evraklar },
          { label: this.$t('Main-Account'), value: this.Ekstreinput ? this.Ekstreinput.AnaHesap : '' },
          { label: this.$t('Currency-Type'), value: this.Ekstreinput && this.Ekstreinput.Doviz ? this.Ekstreinput.Doviz.DovizKod : '' },
          { label: this.$t('Date'), value: this.Ekstreinput && this.Ekstreinput.TarihSec ? this.$t('Maturity') : this.$t('Date') },
          { label: 'Program', value: programType },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? 'Evet' : 'Hayır' },
          { label: this.$t('Options-v2'), value: options.join('; ') }
        ]
      },

      tariheGoreSummaryCards() {
        return [
          {
            title: this.$t('Transfer-Balance'),
            items: [
              { label: this.$t('Transfer-Payable'), value: this.DevirBorc, type: 'money' },
              { label: this.$t('Transfer-Receivable'), value: this.DevirAlacak, type: 'money' },
              { label: this.$t('Transfer-Balance'), value: this.DevirBakiye, type: 'money' }
            ]
          },
          {
            title: this.$t('Current-Period'),
            items: [
              { label: this.$t('Current-Payable'), value: this.DonemBorc, type: 'money' },
              { label: this.$t('Current-Receivable'), value: this.DonemAlacak, type: 'money' },
              { label: this.$t('Current-Period'), value: this.DonemBakiye, type: 'money' }
            ]
          },
          {
            title: this.$t('General-Period'),
            items: [
              { label: this.$t('General-Debit'), value: this.ToplamBorc, type: 'money' },
              { label: this.$t('General-Credit'), value: this.ToplamAlacak, type: 'money' },
              { label: this.$t('General-Period'), value: this.ToplamBakiye, type: 'money' }
            ]
          }
        ]
      }
    },

    watch: {

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      },

      bakiyekontrolsimgeli: function (m) {

        return helpers.bakiyekontrolsimgeli(m);

      }

    },

    methods: {
        getExportCompanyTitleFromCredentials() {
            try {
                var credentials = JSON.parse(window.localStorage.getItem('credentials') || '{}')
                return credentials.SirketUnvani ||
                    credentials.FirmaUnvani ||
                    credentials.SirketAdi ||
                    credentials.FirmaAdi ||
                    credentials.CompanyTitle ||
                    credentials.CompanyName ||
                    ''
            } catch (e) {
                return ''
            }
        },

        getExportCompanyTitle() {
            return this.exportSirketUnvani || this.getExportCompanyTitleFromCredentials() || ''
        },



            openExcelLanguageDialog() {

                var lang = localStorage.getItem('lang') || 'en';

                // Uygulamada kullanılan Deutsch-C+ dili Excel tarafında Almanca olarak indirilir.

                if (lang === 'deC') {

                    lang = 'de';

                }

                if (['tr', 'en', 'fr', 'de'].indexOf(lang) === -1) {

                    lang = 'en';

                }

                this.excelLanguage = lang;

                this.excelLanguageDialog = true;

            },

            closeExcelLanguageDialog() {

                this.excelLanguageDialog = false;

            },

            downloadExcelWithLanguage() {

                var lang = this.excelLanguage || 'en';

                if (['tr', 'en', 'fr', 'de'].indexOf(lang) === -1) {

                    lang = 'en';

                }

                this.excelLanguageDialog = false;

                this.getListExcel(lang);

            },



      openMailDialog() {

  try {

    const credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};

    if (!this.mailPayload.AgentFullName && credentials.UserName) {

      this.mailPayload.AgentFullName = credentials.UserName;

    }

  } catch (e) {}

  this.mailDialog = true;

},

closeMailDialog() {

  this.mailDialog = false;

},

async sendMail() {

  if (!this.$refs.mailForm.validate()) return;

  const url = auth.API_URL + 'api/Abstract/MailGonderTarihEkstre';

  const credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};

  // Tarih aralığını (input) hazırla

  const basT = this.date ? String(this.date).slice(0,10) : this.Ekstreinput.BaslangicTarih;

  const bitT = this.date2 ? String(this.date2).slice(0,10) : this.Ekstreinput.BitisTarih;

  // Evraklar (seçiliyse) -> [{ EvrakKod: '...' }]

  const evraklar = (this.secilenevraklar || []).map(k => ({ EvrakKod: k }));

  // Referanslar (tekil gönderiliyor)

  const refIst = (this.Ekstreinput.ReferansKodIstenilen && this.Ekstreinput.ReferansKodIstenilen.Kod)

    ? { Kod: this.Ekstreinput.ReferansKodIstenilen.Kod }

    : { Kod: null };

  const refNo  = (this.Ekstreinput.ReferansKodIstenmeyen && this.Ekstreinput.ReferansKodIstenmeyen.Kod)

    ? { Kod: this.Ekstreinput.ReferansKodIstenmeyen.Kod }

    : { Kod: null };

  // Doviz

  const dvz = {

    DovizKod: (this.Ekstreinput.Doviz && this.Ekstreinput.Doviz.DovizKod) ? this.Ekstreinput.Doviz.DovizKod : ''

  };

  // API'nin ListWithoutCurrent ile kullandığın modele paralel Input

  const input = {

    BaslangicTarih: basT,

    BitisTarih: bitT,

    ReferansKodIstenilen: refIst,

    ReferansKodIstenmeyen: refNo,

    Evraklar: evraklar,

    AnaHesap: this.Ekstreinput.AnaHesap,

    Doviz: dvz,

    TarihSec: this.Ekstreinput.TarihSec,

    DevirBakiye: this.Ekstreinput.DevirBakiye,

    HesapAdi: this.Ekstreinput.HesapAdi,

    Program: this.Ekstreinput.Program,

    SirketKodu: this.tumsirketler ? 0 : credentials.SirketKodu

  };

  // Mail objesi

  const mail = {

    To: (this.mailPayload.To || '').trim(),

    AgencyName: (this.mailPayload.AgencyName || '').trim(),

    DocType: (this.mailPayload.DocType || '').trim(),

    AgentFullName: (this.mailPayload.AgentFullName || '').trim(),

    CustomBody: (this.mailPayload.CustomBody || '').trim()

  };

  const request = { Input: input, Mail: mail };

  this.mailLoading = true;

  try {

    await this.$http.post(url, request, {

      headers: {

        Authorization: 'Bearer ' + auth.getAuthHeader(),

        'Content-Type': 'application/json'

      }

    });

    this.text1 = 'Mail gönderildi.';

    this.snackbar = true;

    this.closeMailDialog();

  } catch (err) {

    const body = err && err.body ? err.body : {};

    const msg = body.Message || body.message || 'Mail gönderilemedi.';

    this.text1 = msg;

    this.snackbar = true;

  } finally {

    this.mailLoading = false;

  }

},

        getparabirimi() {

        return helpers.getparabirimi()

      },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal

    }

  }









  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {

      CompanyCode: credentials.SirketKodu

    }





    // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {

    //   headers: {

    //     'Authorization': 'Bearer ' + auth.getAuthHeader()

    //   }

    // }).then((response) => {

    //   this.Referans = response.body

    // }, (response) => {

    //   if (response.status === 0) {

    //     this.text1 = 'Service Unavailable'

    //     this.snackbar = true

    //   } else {

    //     this.text1 = 'Service Unavailable'

    //     this.snackbar = true

    //   }

    // })

    this.$http.post(auth.API_URL + 'api/currency/List', {}, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

          if (response.status === 0) {

            this.text = 'Service Unavailable'

            this.snackbar = true

          } else {

            this.text = 'Service Unavailable'

            this.snackbar = true

          }

    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.hesapgurubu = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      }

    })





    this.$http.post(auth.API_URL + 'api/doctype/List', {}, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.evraktipi = response.body

    }, (response) => {

           if (response.status === 0) {

            this.text = 'Service Unavailable'

            this.snackbar = true

          } else {

            this.text = 'Service Unavailable'

            this.snackbar = true

          }

    })

  }

  function filtrekayit() {

    this.filtrevarmi = true

    this.dialogfiltre = false

  }

  function filtreiptal() {

    this.renk1 = 'info'

    this.dialogfiltre = false

    this.filtrevarmi = false

    this.Ekstreinput.BaslangicTarih = null,

      this.Ekstreinput.BitisTarih = null,

      this.Ekstreinput.ReferansKodIstenilen.Kod = null

    this.Ekstreinput.ReferansKodIstenmeyen.Kod = null

    this.Ekstreinput.Evraklar = []

    this.Ekstreinput.AnaHesap = ''

    this.Ekstreinput.Doviz.DovizKod = null

    this.Ekstreinput.TarihSec = false

    this.Ekstreinput.DevirBakiye = false

    this.Ekstreinput.HesapAdi = false

    this.Ekstreinput.Program = 0

    this.Ekstreinput.SirketKodu = 0

    this.tumsirketler = false

  }









  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)

      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.progress = true

        this.currentDebtTotal = 0

        this.currentCreditTotal = 0

        this.debtTotal = 0

        this.creditTotal = 0

        this.load1 = false













        if (this.secilenevraklar.length > 0) {

          this.secilenevraklar.forEach(element => {

            var evrak = {

              EvrakKod: element

            }

            this.Ekstreinput.Evraklar.push(evrak)

          });

        }

        this.Ekstreinput.BaslangicTarih = this.date

        this.Ekstreinput.BitisTarih = this.date2

        if (this.tumsirketler === true) {

          this.Ekstreinput.SirketKodu = 0

        } else {

          this.Ekstreinput.SirketKodu = credentials.SirketKodu

        }





        var params = this.Ekstreinput

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrent', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.items = response.body.EkstreList
          this.exportSirketUnvani =
            (response.body && response.body.SirketUnvani) ||
            (response.body && response.body.EkstreList &&
              response.body.EkstreList[0] && response.body.EkstreList[0].SirketUnvani) ||
            this.getExportCompanyTitleFromCredentials()


          this.text1 = this.$t('Total') + " " + response.body.EkstreList.length + ' ' + this.$t('Number-of-Records-Found')

          this.snackbar = true

          this.DonemBorc = response.body.DonemBorc

          this.DonemAlacak = response.body.DonemAlacak

          this.DonemBakiye = response.body.DonemBakiye

          this.ToplamAlacak = response.body.ToplamAlacak

          this.ToplamBorc = response.body.ToplamBorc

          this.ToplamBakiye = response.body.ToplamBakiye

          this.DevirAlacak = response.body.DevirAlacak

          this.DevirBorc = response.body.DevirBorc

          this.DevirBakiye = response.body.DevirBakiye

          this.load1 = true

          this.progress = false

        }, (response) => {

          if (response.status === 0) {

            this.text = 'Service Unavailable'

            this.snackbar = true

            this.load1 = true

            this.progress = false

          } else {

            this.text = 'Service Unavailable'

            this.snackbar = true

            this.load1 = true

            this.progress = false

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }

































  function getListHtml() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var lang = localStorage.getItem('lang')

    this.progress = true

    this.currentDebtTotal = 0

    this.currentCreditTotal = 0

    this.debtTotal = 0

    this.creditTotal = 0

    this.load1 = false









    if (this.secilenevraklar.length > 0) {

      this.secilenevraklar.forEach(element => {

        var evrak = {

          EvrakKod: element

        }

        this.Ekstreinput.Evraklar.push(evrak)

      });

    }

    this.Ekstreinput.BaslangicTarih = this.date

    this.Ekstreinput.BitisTarih = this.date2

    if (this.tumsirketler === true) {

      this.Ekstreinput.SirketKodu = 0

    } else {

      this.Ekstreinput.SirketKodu = credentials.SirketKodu

    }





    var params = this.Ekstreinput













    this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrentHtml', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.load = false

      this.load1 = true

      this.progress = false

      if (lang=='en')

          {

            response.bodyText=response.bodyText.toString().replaceAll(" B"," D");

            response.bodyText=response.bodyText.toString().replaceAll(" A"," C");

             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> TARİHE GÖRE EKSTRESİ </title>','<title> EXTRACT BY DATE </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>TARİHE GÖRE EKSTRESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>EXTRACT BY DATE</font>")





             response.bodyText=bodyhtml;

          }

      var blob = new Blob([response.bodyText], {

        type: 'application/html'

      });

      var link = document.createElement('a');

      link.href = window.URL.createObjectURL(blob);

      link.download = this.$t('DateExtract') + ".html";

      link.click();

    }, (response) => {

      if (response.status === 0) {

        this.text = 'Service Unavailable'

        this.snackbar = true

        this.load1 = true

        this.progress = false

      } else {

        this.text = 'Service Unavailable'

        this.snackbar = true

        this.load1 = true

        this.progress = false

      }

    })

  }

  function getListExcel(exportLang) {

    exportLang = exportLang || 'en'

    if (exportLang === 'deC') { exportLang = 'de' }

    if (['tr', 'en', 'fr', 'de'].indexOf(exportLang) === -1) { exportLang = 'en' }



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.progress = true

    this.currentDebtTotal = 0

    this.currentCreditTotal = 0

    this.debtTotal = 0

    this.creditTotal = 0

    this.load1 = false









    if (this.secilenevraklar.length > 0) {

      this.secilenevraklar.forEach(element => {

        var evrak = {

          EvrakKod: element

        }

        this.Ekstreinput.Evraklar.push(evrak)

      });

    }

    this.Ekstreinput.BaslangicTarih = this.date

    this.Ekstreinput.BitisTarih = this.date2

    if (this.tumsirketler === true) {

      this.Ekstreinput.SirketKodu = 0

    } else {

      this.Ekstreinput.SirketKodu = credentials.SirketKodu

    }





    var params = this.Ekstreinput













    this.$http.post(auth.API_URL + "api/Abstract/ListWithoutCurrentExcel?lang=" + encodeURIComponent(exportLang), params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      },

      responseType: "arraybuffer"

    }).then((response) => {

      this.load = false

      this.load1 = true

      this.progress = false

      var blob = new Blob([response.data], {

        type: 'application/xlsx'

      });

      var link = document.createElement('a');

      link.href = window.URL.createObjectURL(blob);

      link.download = this.$t('DateExtract') + ".xlsx";

      link.click();

    }, (response) => {

      if (response.status === 0) {

        this.text = 'Service Unavailable'

        this.snackbar = true

        this.load1 = true

        this.progress = false

      } else {

        this.text = 'Service Unavailable'

        this.snackbar = true

        this.load1 = true

        this.progress = false

      }

    })

  }

  function beforeMount() {

    this.Ekstreinput.ReferansKodIstenilen.Kod = null

    this.Ekstreinput.ReferansKodIstenmeyen.Kod = null

  }

</script>

<style scoped>
.tarihe-gore-report-table { width: 100%; margin-top: 4px; }
.tarihe-gore-report-table > * { width: 100%; }
</style>
